export class AiPersonasApi {
  #http;

  constructor(http) {
    this.#http = http;
  }

  async getAiPersonas({ signal, ...params } = {}) {
    return this.#http.get('/ai-personas', { params, signal });
  }

  async getAiPersonaById(id) {
    return this.#http.get(`/ai-personas/${id}`);
  }

  async createAiPersona(body) {
    return this.#http.post('/ai-personas', body);
  }

  async updateAiPersona({ id, ...body }) {
    return this.#http.put(`/ai-personas/${id}`, body);
  }

  async deleteAiPersona(id) {
    return this.#http.delete(`/ai-personas/${id}`);
  }

  async getGlobalAiPersonas({ signal } = {}) {
    return this.#http.get('/ai-personas/templates', { signal });
  }

  async cloneAiPersona(id) {
    return this.#http.post(`/ai-personas/${id}/clone`);
  }

  async getAiPersonaSecurityGroups(id) {
    return this.#http.get(`/ai-personas/${id}/security-groups`);
  }

  async setAiPersonaSecurityGroups(id, securityGroupIds) {
    return this.#http.put(`/ai-personas/${id}/security-groups`, securityGroupIds);
  }
}
